import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { api, formatApiErrorDetail } from "../lib/api";
import { usePageMeta } from "../hooks/usePageMeta";

export default function AdminLoginPage() {
  usePageMeta("Admin Login | MacWay Estate Services", "MacWay Estate Services team login.");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data.token) localStorage.setItem("macway_admin_token", data.token);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-[70vh] bg-sand flex items-center justify-center py-16 px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-white border border-linen p-8 md:p-10">
        <div className="flex flex-col items-center text-center">
          <div className="w-12 h-12 bg-forest flex items-center justify-center">
            <Lock className="w-5 h-5 text-brass" />
          </div>
          <h1 className="mt-5 text-3xl font-medium text-ink" data-testid="admin-login-heading">MacWay Team Login</h1>
          <p className="mt-2 text-sm text-ink/60">Quote requests & customer details</p>
        </div>

        <form onSubmit={handleSubmit} className="mt-8 space-y-5" data-testid="admin-login-form">
          <div>
            <label htmlFor="admin-email" className="form-label">Email</label>
            <input
              id="admin-email"
              type="email"
              className="form-input"
              required
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email"
            />
          </div>
          <div>
            <div className="flex items-center justify-between mb-1.5">
              <label htmlFor="admin-password" className="form-label mb-0">Password</label>
              <Link to="/admin/forgot-password" className="text-xs font-semibold text-forest hover:text-brass transition-colors" data-testid="forgot-password-link">
                Forgot password?
              </Link>
            </div>
            <input
              id="admin-password"
              type="password"
              className="form-input"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-login-password"
            />
          </div>
          {error && (
            <p className="text-sm font-semibold text-red-700 bg-red-50 border border-red-200 px-4 py-3" role="alert" data-testid="admin-login-error">
              {error}
            </p>
          )}
          <button type="submit" disabled={loading} className="btn-primary w-full disabled:opacity-60" data-testid="admin-login-submit">
            {loading ? (
              <>
                <Loader2 className="w-4 h-4 animate-spin" /> Signing in…
              </>
            ) : (
              "Sign In"
            )}
          </button>
        </form>
      </div>
    </main>
  );
}
